// 请求拦截器 - 自动添加Token和处理认证
import { message } from 'antd';
import type { RequestOptions } from '@umijs/max';
import { getAuthHeader, isTokenValid, autoRefreshToken, handleTokenExpired, forceLogout } from './token';

// 正在刷新token的标志
let isRefreshing = false;
// 待重试的请求队列
let failedQueue: Array<{
  resolve: (value: any) => void;
  reject: (error: any) => void;
}> = [];

// 处理队列中的请求
const processQueue = (error: any, token: string | null = null) => {
  failedQueue.forEach(({ resolve, reject }) => {
    if (error) {
      reject(error);
    } else {
      resolve(token);
    }
  });

  failedQueue = [];
};

// 请求拦截器函数
export const requestInterceptor = (config: RequestOptions) => {
  // 自动添加认证头
  const authHeaders = getAuthHeader();
  if (authHeaders.Authorization) {
    config.headers = {
      ...config.headers,
      ...authHeaders,
    };
  }

  // 详细日志输出
  console.log('🚀 Request interceptor:', {
    url: config.url,
    method: config.method,
    hasAuth: !!authHeaders.Authorization,
    authHeader: authHeaders.Authorization ?
      `${authHeaders.Authorization.substring(0, 20)}...` :
      'None',
    headers: config.headers,
  });

  return config;
};

// 响应拦截器函数
export const responseInterceptor = (response: any) => {
  console.log('Response interceptor:', {
    url: response.config?.url,
    status: response.status,
    success: response.data?.success,
  });

  return response;
};

// 响应错误拦截器函数
export const responseErrorInterceptor = async (error: any, options?: RequestOptions) => {
  const originalRequest = error.config || options;

  console.error('Response interceptor error:', {
    url: originalRequest?.url || error.config?.url,
    status: error.response?.status,
    data: error.response?.data,
  });

  // 处理401未授权错误 - 直接退出登录
  if (error.response?.status === 401) {
    console.log('🚨 401 Unauthorized - 检测到认证失败，直接退出登录');

    // 停止所有正在进行的token刷新流程
    if (isRefreshing) {
      isRefreshing = false;
      processQueue(error);
    }

    // 获取错误信息
    const errorMessage = error.response?.data?.message || 'Token已失效，请重新登录';

    // 直接强制退出登录
    forceLogout(errorMessage);

    return Promise.reject(error);
  }

  // 处理其他错误
  if (error.response?.status === 403) {
    message.error('权限不足，无法访问该资源');
  } else if (error.response?.status >= 500) {
    message.error('服务器错误，请稍后重试');
  } else if (!error.response) {
    message.error('网络错误，请检查网络连接');
  }

  return Promise.reject(error);
};

// 默认导出所有拦截器
export default {
  requestInterceptor,
  responseInterceptor,
  responseErrorInterceptor,
};
